var _rect, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSubtopicStarterIconColour(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    rx: 10,
    fill: "#EC5BB2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9166 15.2924C10.9166 13.6816 12.2225 12.3757 13.8333 12.3757H15.2916C16.9025 12.3757 18.2083 13.6816 18.2083 15.2924V35.7091C18.2083 37.3199 16.9025 38.6257 15.2916 38.6257H13.8333C12.2225 38.6257 10.9166 37.3199 10.9166 35.7091V15.2924Z",
    fill: "white",
    fillOpacity: 0.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6666 15.2924C19.6666 13.6816 20.9725 12.3757 22.5833 12.3757H24.0416C25.6525 12.3757 26.9583 13.6816 26.9583 15.2924V35.7091C26.9583 37.3199 25.6525 38.6257 24.0416 38.6257H22.5833C20.9725 38.6257 19.6666 37.3199 19.6666 35.7091V15.2924Z",
    fill: "white",
    fillOpacity: 0.6
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3573 16.5839C26.9404 15.0279 27.8638 13.4286 29.4197 13.0117L30.8283 12.6343C32.3843 12.2174 33.9836 13.1407 34.4005 14.6967L39.6847 34.4176C40.1016 35.9736 39.1783 37.5729 37.6223 37.9898L36.2137 38.3673C34.6578 38.7842 33.0584 37.8608 32.6415 36.3049L27.3573 16.5839Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubtopicStarterIconColour);
export default __webpack_public_path__ + "static/media/SubtopicStarterIconColour.59870ca2f14b63131ae9e52f75c2f1d1.svg";
export { ForwardRef as ReactComponent };